import { render, staticRenderFns } from "./N2OsDados.vue?vue&type=template&id=5d0f0bd0&scoped=true"
import script from "./N2OsDados.vue?vue&type=script&lang=js"
export * from "./N2OsDados.vue?vue&type=script&lang=js"
import style1 from "./N2OsDados.vue?vue&type=style&index=1&id=5d0f0bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0f0bd0",
  null
  
)

export default component.exports